module.exports = __webpack_public_path__ + "h5/img/one.2814de22.png";